import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import FilmCard from "@/components/feature/FilmCard";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { hotFilms, films } from "@/lib/films";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import FeaturePicks from "./components/FeaturePicks";
import SiteIntro from "./components/SiteIntro";
import TopChart from "./components/TopChart";

const hot = hotFilms(12);
const ticker = films.slice(0, 10).map((film) => film.title);

export default function Home() {
  useDocumentMeta(
    "三级片电影推荐与剧情介绍 - 三级片影视大全",
    "三级片为您提供丰富的三级片电影资源，覆盖经典与最新作品，提供剧情介绍和影片分类，满足您的影视娱乐需求。",
    "三级片,三级片电影,三级片推荐,三级片剧情,三级片资源,三级片影视,三级片大全"
  );

  return (
    <SiteLayout>
      <HeroCarousel />

      <div className="w-full overflow-hidden border-y border-background-300 bg-background-100 py-3">
        <div className="flex w-max marquee-track items-center gap-6">
          {[...ticker, ...ticker].map((title, index) => (
            <span key={`${title}-${index}`} className="flex items-center gap-6">
              <span className="font-label text-xs tracking-wide text-foreground-600">{title}</span>
              <span className="h-1 w-1 rounded-full bg-accent-500" />
            </span>
          ))}
        </div>
      </div>

      <section className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16 lg:px-12">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">Trending now</p>
            <h1 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              三级片电影推荐与剧情介绍
            </h1>
            <p className="mt-2 font-body text-sm text-foreground-600">按站内热度选出的 12 部作品，点击海报查看完整剧情介绍。</p>
          </div>
          <Link
            to="/category"
            className="flex h-10 shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md border border-background-300 px-4 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-500 sm:self-auto"
          >
            查看全部影片
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-6">
          {hot.map((film, index) => (
            <FilmCard key={film.id} film={film} index={index} />
          ))}
        </div>
      </section>

      <TopChart />

      <CategoryEntry />

      <FeaturePicks />

      <SiteIntro />
    </SiteLayout>
  );
}